import {FC, ReactElement} from 'react'
import classNames from 'classnames'

interface NoteMessageWrapperProps {
  classes?: string
  children: ReactElement
}
export const NoteMessageWrapper: FC<NoteMessageWrapperProps> = ({
  classes,
  children,
}) => {
  return (
    <div
      className={classNames(
        'p-3 flex items-center justify-center border border-yellow-100 bg-yellow-100 bg-opacity-20',
        classes,
      )}
    >
      {children}
    </div>
  )
}
